import React from "react";

const Organiser = () => {
  return (
    <>
      {/* About PVG */}
      <div className="aboutOrg">
        <h3 className="aboutOrg-title">About PVG</h3>
        <div className="aboutOrg-wrapper">
          <div className="aboutOrg-img">
            <img
              src="https://lh5.googleusercontent.com/p/AF1QipMgibdomv9YPvlIKe8V-lxS7jvb92UkSPJswkCx=w1080-k-no"
              alt="Pune vidyarthi griha sanstha image"
            />
          </div>
          <p className="aboutOrg-des">
            The parent institute Pune Vidyarthi Griha (PVG) is a well-known
            Charitable Institution of Maharashtra, established in 1909, by a
            group of dedicated and visionary educationists. The primary mission
            of the Institute is to provide progressive and value-added education
            facilities for the deserving, poor students of the society. Today,
            the institution has grown into a big banyan tree with its branches
            spread across Pune, Mumbai, and Nashik. PVG's various institutions
            conduct a wide spectrum of education programs from Pre-primary to
            Higher education, in professional fields like Engineering
            Technology, Management, Computer Science, and Commerce & Science
            College etc. PVG has been the only institute in India, which has
            striven hard for professional education in the Printing field since
            1926 and has taken the lead in establishing degree and diploma in
            Printing Technology, approved by the All India Council for Technical
            Education. PVG has a modern Printing Press and Publications
            division. It has published mainly technical books, which are
            standard & very popular.
          </p>
        </div>
        <svg
          className="bg-blob1"
          viewBox="0 0 200 200"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#BBDEFB"
            d="M43.9,-30.8C57.2,-18.3,68.6,-0.1,62.7,9.8C56.9,19.7,33.9,21.2,13.8,32.2C-6.3,43.3,-23.5,63.9,-37.2,62.8C-51,61.8,-61.2,39,-61.2,19.5C-61.3,0,-51.1,-16.3,-39.1,-28.5C-27.2,-40.6,-13.6,-48.7,0.8,-49.4C15.3,-50.1,30.6,-43.3,43.9,-30.8Z"
            transform="translate(100 100)"
          />
        </svg>
        <svg
          className="bg-blob2"
          viewBox="0 0 200 200"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#BBDEFB"
            d="M49.8,-45.9C53.7,-34.8,38.6,-14.7,33.6,7.8C28.6,30.4,33.7,55.4,25.2,64.1C16.7,72.7,-5.4,64.9,-19.2,53.2C-32.9,41.4,-38.3,25.7,-37,13.5C-35.8,1.3,-27.9,-7.4,-20.7,-19.2C-13.4,-31.1,-6.7,-46.2,8.1,-52.7C22.9,-59.2,45.9,-57,49.8,-45.9Z"
            transform="translate(100 100)"
          />
        </svg>
      </div>
      {/* About PVG Ends */}

      {/* About SPPU  */}
      <div className="about__sppu">
        <h3 className="about__sppu-title">About SPPU</h3>
        <p className="about__sppu-des">
          Savitribai Phule Pune University (formerly University of Pune) was
          established on February 10, 1949 under the Poona University Act. The
          university houses 52 academic departments. It is popularly known as
          the 'Oxford of the East'. It has about 307 recognized research
          institutes and 950 affiliated colleges offering graduate and
          under-graduate courses. Due to its excellent reputation and facilities
          the university attracts many foreign students. The Mission of
          Savitribai Phule Pune University is to be a global, socially conscious
          Center of Excellence in the conservation, creation, advancement and
          dissemination of knowledge . It is equipped to take up challenges of
          the enormous change taking place all around and committed to empower
          its faculty and students to contribute meaningfully to economic,
          technological and social development.
          <br />
          <br /> The Department of Education & Extension welcomes all the
          students who aspire to build their Career in Education. This
          Department was established in 1990 which aims at research and is a
          higher learning centre. Under Extension activities Department has
          established 'Advance Technology Blind Students Learning Center'.This
          centre is equipped with computer facility and advanced learning
          software for visually impaired.
        </p>
      </div>
      {/* About SPPU Ends  */}

      {/* About PVGCOET and GKP(W)IM */}
      <div className="aboutClg">
        <h3 className="aboutClg-title">About PVGCOET & GKP(W)IM</h3>
        <div className="aboutClg-wrapper">
          <div className="aboutClg-img">
            <img
              src="https://images.goklassifieds.com/2020/05/PVGs-College-of-Engineering-and-Technology-Pune-Cover.jpg"
              alt="PVGCOET Pune"
            />
          </div>
          <p className="aboutClg-des">
            Established in 1985, Pune Vidyarthi Griha's College of Engineering
            and Technology and G.K. Pate (Wani) Institute of Management
            (formerly known as College of Engineering and Technology) is
            approved by AICTE and affiliated to the Savitribai Phule Pune
            University and accredited 'A' Grade by NAAC in 2nd cycle. It is one
            of the reputed engineering college in India. In 2020, the institute
            has merged with G. K. Pate (Wani) Institute of Management (GKP (W)
            IM) for the management programme. The PVG's COET and GKP(W) IM runs
            undergraduate programmes in Printing Technology, Mechanical
            Engineering, Electrical Engineering, Electronics &
            Tele-communication Engineering, Computer Engineering, Information
            Technology, Artificial Intelligence and Data-Science, and
            postgraduate programmes in Electrical Engineering, Printing
            Technology, and Business Administration. The college also runs PhD
            programmes in Printing Technology, Mechanical Engineering and
            Electrical Engineering.
          </p>
        </div>
        <svg
          className="bg-blob6"
          viewBox="0 0 200 200"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#FFDDE1"
            d="M41.9,-57C45.4,-47,33.1,-25.3,29.8,-10.3C26.5,4.8,32.1,13.3,30.1,17.8C28,22.3,18.2,22.8,7.8,30.6C-2.6,38.4,-13.8,53.4,-23.2,54.1C-32.6,54.9,-40.2,41.2,-50.8,27.2C-61.3,13.2,-74.8,-1.2,-71.6,-11.5C-68.4,-21.8,-48.6,-28,-33.8,-36C-19.1,-44,-9.6,-53.9,4.8,-59.6C19.2,-65.4,38.4,-67,41.9,-57Z"
            transform="translate(100 100)"
          />
        </svg>
      </div>
      {/* About PVGCOET and GKP(W)IM Ends */}

      {/* About E&TC Department  */}
      <div className="about__entc">
        <h3 className="about__entc-title">About E&TC Department</h3>
        <p className="about__entc-des">
          The Electronics and Telecommunication Engineering Department was
          established in 1991 with undergraduate programme in E&TC. The
          department has qualified, experienced and dedicated teaching staff.
          Department emphasizes an effective teaching-learning process with an
          excellent teaching-learning environment. The department offers honours
          courses in AI-ML and Electric Vehicle in addition to regular
          undergraduate programme and promotes internships and online courses
          like NPTEL, COURSERA etc for effective learning. The department
          inspires its students for problem based / project based / outcome
          based learning. The department staff is actively involved and
          contributed to many interdisciplinary platforms like VLAB, ED cell,
          Robotics Club, GATE training facility and Institute's Innovation Cell
          (IIC). The department has a remarkable and outstanding students'
          association, TESA. The department has a Smart Classroom, a niche
          facility as the platform for Digital Teaching and Learning. It has a
          strong network of distinguished and successful alumni contributing and
          sharing their knowledge for its continual progress. The department of
          E&TC has strong placement records and the alumni of the department are
          working in many prestigious companies like Google, Microsoft, Intel
          Corporation, Infosys, TCS, Wipro, IBM, KPIT, Persistent Systems,
          Siemens, Fanuc, RAJA software, Mitsubishi and many more. Besides, the
          department runs Study Work Go Japan: An International Recruitment
          Program for placements in Japanese companies and successfully placed
          many students. Many of the students of the department successfully got
          admitted to higher studies in IITs and prestigious universities in
          USA, Australia, Germany, Canada etc. Few of them became entrepreneurs
          as well.
        </p>
      </div>
      {/* About E&TC Department Ends  */}

      {/* Vision */}
      <div className="vision">
        <h3 className="vision-title">Vision</h3>
        <p className="vision-des">
          To achieve excellence in engineering education
        </p>
      </div>
      {/* Vision Ends */}

      {/* Mission */}
      <div className="mission">
        <h3 className="mission-title">Mission</h3>
        <ol className="mission-list">
          <li className="mission-item">To satisfy all stakeholders</li>
          <li className="mission-item">
            To develop ethical, highly motivated engineering professionals with
            good human values, requisite skills and competencies
          </li>
          <li className="mission-item">
            To adopt innovative teaching mechanisms
          </li>
          <li className="mission-item">To promote research culture.</li>
          <li className="mission-item">
            To contribute to country's economic developments.
          </li>
          <li className="mission-item">
            To be responsive to changes in technology, socioeconomic and
            environmental conditions.
          </li>
        </ol>
      </div>
      {/* Mission Ends */}

      {/* Advisory Commitee  */}

      <div className="adv-commitee">
        <h3 className="adv-commitee-title">Advisory Commitee</h3>
        <ol className="adv-commitee-list">
          <li className="adv-commitee-item">
            Dr. Manohar Chaskar, Dean, Faculty of Science & Technology, SPPU,
            Pune
          </li>
          <li className="adv-commitee-item">
            Dr. Prafulla Pawar, Resgistrar, Savitribai Phule University
            Dean-faculty of Commerce and Management, Savitribai Phule Pune
            University, Formerly Professor and Head, Department of Managemnet of
            Sciences(PUMBA),Savitribai Phule Pune University
          </li>
          <li className="adv-commitee-item">
            Dr. Arvind Shaligram, Professor Emeritus, Electronic Science and
            CEO, SPPU Research Park Foundation
          </li>
          <li className="adv-commitee-item">
            Dr. Aditya Abhyankar, Bos (IT) Sppu, Pune and Dean, Professor and
            Head,Department of Technology, Sppu, Pune
          </li>
          <li className="adv-commitee-item">
            Prof. Bhuvanesh Kulkarni, Director, Edutech Catalyst
          </li>
          <li className="adv-commitee-item">
            Dr. Megha Uplane, Ex-professor And Head of Department of Education
            and Extension, Savitribai Phule Pune University, Pune
          </li>
          <li className="adv-commitee-item">
            Dr. Dattatray Bormane, Principal, Aissms Coe, Pune
          </li>
          <li className="adv-commitee-item">
            Dr. Priti Rege, Retd. Professor, E&TC Department, College of
            Engineering,Pune
          </li>
          <li className="adv-commitee-item">
            Dr. M. S. Thakare, Head, Electrical Department, PVG's COET &
            GKP(W)IM, Pune
          </li>
          <li className="adv-commitee-item">
            Dr.Manmohan Bhoomkar, Head, Mechanical Department, PVG's COET &
            GKP(W)IM, Pune
          </li>
          <li className="adv-commitee-item">
            Prof. Madhura Mahajan, Head, Printing Department, PVG's COET &
            GKP(W)IM, Pune
          </li>
          <li className="adv-commitee-item">
            Dr.Surendra Mahajan, Head, IT Department, PVG's COET & GKP(W)IM,
            Pune
          </li>
          <li className="adv-commitee-item">
            Prof. Deepak Sapkal, Head, Computer Department, PVG's COET &
            GKP(W)IM, Pune
          </li>
          <li className="adv-commitee-item">
            Dr. Kalpana Lodha, Head, MBA Department,PVG's COET & GKP(W)IM, Pune
          </li>
          <li className="adv-commitee-item">
            Prof. A. S. Waghmare, Fe, Dean, Applied Science Department,PVG's
            COET & GKP(W)IM, Pune
          </li>
        </ol>
        <svg
          className="bg-blob3"
          viewBox="0 0 200 200"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#FFDDE1"
            d="M16.9,-6.3C24.8,-3.5,36.3,3.7,36.3,10.2C36.4,16.6,24.9,22.3,12.5,29.7C0.1,37.1,-13.3,46.2,-28.4,44.5C-43.6,42.8,-60.5,30.2,-65.8,13.3C-71.1,-3.7,-64.7,-25.1,-51.8,-29C-38.8,-33,-19.4,-19.4,-7.5,-13.5C4.5,-7.5,8.9,-9.1,16.9,-6.3Z"
            transform="translate(100 100)"
          />
        </svg>
        <svg
          className="bg-blob7"
          viewBox="0 0 200 200"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="#FFDDE1"
            d="M51.1,-47.4C56.6,-33.8,44.8,-13.2,39.3,8.1C33.7,29.4,34.5,51.2,27,54C19.6,56.8,3.9,40.5,-7,29.5C-17.9,18.5,-24.1,12.7,-26.5,5.3C-28.8,-2.2,-27.2,-11.3,-22.2,-24.7C-17.1,-38.2,-8.5,-55.9,7.1,-61.6C22.8,-67.2,45.6,-60.9,51.1,-47.4Z"
            transform="translate(100 100)"
          />
        </svg>
      </div>

      {/* Advisory Commitee Ends */}
    </>
  );
};

export default Organiser;
